import { render, staticRenderFns } from "./ProfessionalArticleList.vue?vue&type=template&id=19ee595b&scoped=true"
import script from "./ProfessionalArticleList.vue?vue&type=script&lang=js"
export * from "./ProfessionalArticleList.vue?vue&type=script&lang=js"
import style0 from "./ProfessionalArticleList.vue?vue&type=style&index=0&id=19ee595b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ee595b",
  null
  
)

export default component.exports